import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function LegalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-legal",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1044:40606)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 7,
    width: 4,
    height: 44,
    rx: 2,
    fill: "#F7C14E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 47,
    width: 12,
    height: 5,
    rx: 2.5,
    fill: "#F7C14E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 52,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#F7C14E"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#914E00",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M23 51h14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 7,
    r: 3,
    fill: "#F7C14E"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#914E00",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M29 10h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 43l-7.5-26L4 43",
    stroke: "#75AFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.952 43c-.815 0-1.27.912-.712 1.505C3.85 47.28 7.482 49 11.5 49s7.651-1.72 10.26-4.495c.558-.593.103-1.505-.712-1.505H1.952z",
    fill: "#F7C14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.212 14.017c12.55 1.225 11.271-6.437 25.347-1.114.26.098.441.351.441.628V15c-12.418-5.275-16.212 1.654-25.855-.617A.188.188 0 013 14.202c0-.11.102-.196.212-.185zM56.788 14.017c-12.55 1.225-11.271-6.437-25.347-1.114a.682.682 0 00-.441.628V15c12.418-5.275 16.212 1.654 25.855-.617a.188.188 0 00.145-.181.192.192 0 00-.212-.185z",
    fill: "#F7C14E",
    stroke: "#F7C14E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 43l7.5-26L56 43",
    stroke: "#75AFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.048 43c.815 0 1.27.912.712 1.505C56.15 47.28 52.518 49 48.5 49s-7.651-1.72-10.26-4.495c-.558-.593-.103-1.505.712-1.505h19.096z",
    fill: "#F7C14E"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1044:40606"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  }))));
}